import {
  EuiContextMenu,
  EuiContextMenuPanelDescriptor,
  EuiHeaderSectionItem,
  EuiHeaderSectionItemButton,
  EuiIcon,
  EuiPopover,
  htmlIdGenerator,
} from "@inscopix/ideas-eui";
import { useGetDemoProjects } from "hooks/useGetProjects";
import { getEnvVar } from "ideas.env";
import { ideasFeatures } from "ideas.features";
import { useFlyoutContext } from "providers/FlyoutProvider/FlyoutProvider";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { memo, useMemo, useState, useCallback } from "react";

export const HelpMenu = memo(function HelpMenu() {
  const URL_DOCS = getEnvVar("URL_DOCS");
  const projectPath = useRouteMapContext((s) => s.routeMap.PROJECT.dynamicPath);
  const { setFlyout } = useFlyoutContext();
  const [isOpen, setIsOpen] = useState(false);
  const closePopover = useCallback(() => setIsOpen(false), []);

  const { demoProjects } = useGetDemoProjects();

  const handleContactSupportClick = useCallback(() => {
    setFlyout("contactSupport");
    closePopover();
  }, [setFlyout, closePopover]);

  const panels = useMemo(() => {
    const panels: EuiContextMenuPanelDescriptor[] = [
      {
        id: 0,
        items: [
          {
            name: "Getting Started",
            icon: "documentation",
            href: `${URL_DOCS}/create-project.html`,
            target: "_blank",
          },
          {
            name: "Analysis Tools",
            icon: "documentation",
            href: `${URL_DOCS}/tools/`,
            target: "_blank",
          },
          {
            name: "Contact Support",
            icon: "email",
            onClick: handleContactSupportClick,
          },
        ],
      },
    ];
    if (ideasFeatures.demoProjects && demoProjects && demoProjects.length > 0) {
      panels[0]["items"]?.push({
        name: "Demo Projects",
        icon: "dashboardApp",
        toolTipContent: "Browse example projects",
        panel: 1,
      });
      panels.push({
        id: 1,
        title: "Demo projects",
        items: demoProjects.map((project) => {
          return {
            name: project.name,
            onClick: () =>
              projectPath({
                tenantKey: project.tenantKey,
                projectKey: project.key,
              }).navigateTo(),
          };
        }),
      });
    }
    return panels;
  }, [URL_DOCS, demoProjects, handleContactSupportClick, projectPath]);

  const button = (
    <EuiHeaderSectionItemButton
      aria-controls={htmlIdGenerator()()}
      aria-expanded={isOpen}
      aria-haspopup="true"
      aria-label="Button to open help menu"
      onClick={() => setIsOpen(!isOpen)}
    >
      <EuiIcon type="questionInCircle" size="l" />
    </EuiHeaderSectionItemButton>
  );

  return (
    <>
      <EuiHeaderSectionItem>
        <EuiPopover
          id={htmlIdGenerator()()}
          ownFocus
          button={button}
          isOpen={isOpen}
          anchorPosition="downRight"
          closePopover={closePopover}
        >
          <EuiContextMenu initialPanelId={0} panels={panels} />
        </EuiPopover>
      </EuiHeaderSectionItem>
    </>
  );
});
